import React, {useState} from "react";
import mainlogo from '../assets/images/mainlogo.png';
import chlogo from '../assets/images/ch_logo.png';
import { Link } from "react-router-dom";
import dashboardicon from '../assets/images/sidebar/Dashboard.svg';
import shoppingcarticon from '../assets/images/sidebar/ShoppingCart.svg';
import sidebar_home from '../assets/images/sidebar/sidebar_home.svg';
import sidebar_user from '../assets/images/sidebar/sidebar_user.svg';
import sidebar_products from '../assets/images/sidebar/sidebar_products.svg';
import sidebar_customer from '../assets/images/sidebar/sidebar_customers.svg';
import sidebar_order from '../assets/images/sidebar/sidebar_orders.svg';
import sidebar_sales from '../assets/images/sidebar/sidebar_sales.svg';
import sidebar_inventory from '../assets/images/sidebar/sidebar_inventory.svg';
import sidebar_discounts from '../assets/images/sidebar/sidebar_discounts.svg';
import sidebar_refunds from '../assets/images/sidebar/sidebar_refund.svg';
import sidebar_reviews from '../assets/images/sidebar/sidebar_review.svg';
import sidebar_signout from '../assets/images/sidebar/sidebar_signout.svg';
import sidebar_home1 from '../assets/images/sidebar/sidebar_home1.svg';
import sidebar_users1 from '../assets/images/sidebar/sidebar_users1.svg';
import sidebar_products1 from '../assets/images/sidebar/sidebar_products1.svg';
import sidebar_customer1 from '../assets/images/sidebar/sidebar_customers1.svg';
import sidebar_order1 from '../assets/images/sidebar/sidebar_order1.svg';
import sidebar_sales1 from '../assets/images/sidebar/sidebar_sales1.svg';
import sidebar_inventory1 from '../assets/images/sidebar/sidebar_inventory1.svg';
import sidebar_discounts1 from '../assets/images/sidebar/sidebar_discounts1.svg';
import sidebar_refunds1 from '../assets/images/sidebar/sidebar_refunds1.svg';
import sidebar_reviews1 from '../assets/images/sidebar/sidebar_reviews1.svg';
import sidebar_signout1 from '../assets/images/sidebar/sidebar_signout1.svg';
import { useLocation } from 'react-router-dom';

import { faClipboardUser, faSquarePollHorizontal, faHospitalUser, faChartSimple, faUsers, faStore, faClipboardList, faUser } from "@fortawesome/free-solid-svg-icons";
import { faImage } from "@fortawesome/free-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useDispatch, useSelector } from 'react-redux';

const Sidebar = () => {
  const [selectedindex, setselectedindex] = useState(0);
  const userdata = useSelector((store) => store.userReducer.userdata)
    var navdata = [
        {name: 'Dashboard', icon: faChartSimple, activeicon: faChartSimple, route: 'dashboard', access: ['superadmin', 'admin']},
        {name: 'Risk Review Audit', icon: faSquarePollHorizontal, activeicon: faSquarePollHorizontal, route: 'risk-review-audit', access: ['superadmin', 'admin']},
        // {name: 'Branch', icon: faSquarePollHorizontal, activeicon: faSquarePollHorizontal, route: 'branch', access: ['superadmin', 'admin']},
        // {name: 'Staff', icon: faClipboardUser, activeicon:faClipboardUser, route: 'staff', access: ['superadmin', 'admin']},
        // {name: 'Borrower', icon: faHospitalUser, activeicon: faHospitalUser, route: 'borrower', access: ['superadmin', 'admin']},
        {name: 'Market', icon: faStore, activeicon:faStore, route: 'market', access: ['superadmin', 'admin']},
        {name: 'Avanti Special Audit', icon: faClipboardList, activeicon: faClipboardList, route: 'avanti-special-audit', access: ['superadmin', 'admin']},
        {name: 'Employees', icon: faUser, activeicon: faUser, route: 'employees-list', access: ['superadmin', 'admin']},
        {name: 'Users', icon: faUsers, activeicon:faUsers, route: 'users', access: ['superadmin']}
    ];
    const location = useLocation();
    console.log('location.pathname >>>', location.pathname);
    return (
        <div className="sidebarmaindiv">
            {/* <img src={mainlogo} className="sidebarlogo" /> */}
            <img src={chlogo} className="sidebarlogo" />
            <div className="sidebarnavmaindiv">
                {navdata?.map((item, index) => {
                  if(item?.access?.includes(userdata?.type)) {
                    var mainclass = "sidebarnavrow";
                    var iconname = item?.icon;
                    if(location.pathname == "/"+item.route) {
                        mainclass = "sidebarnavrow active";
                        iconname = item?.activeicon;
                    }
                    return (
                      <Link
                        to={"/" + item.route}
                        className={mainclass}
                        key={index}
                        onClick={() => {
                          setselectedindex(index);
                        }}
                      >
                        <FontAwesomeIcon
                          icon={item?.icon}
                        //   fontSize={19}
                          className="sidebarnavicon"
                          style={{
                            marginLeft: 15,
                            cursor: "pointer",
                          }}
                        />
                        <p className="shoppingtext">{item.name}</p>
                      </Link>
                    );
                  }
                   
                })}
                
            </div>
        </div>
    )
}

export default Sidebar